import { GetServerSideProps } from "next";

import { serializeModel } from "@/server/lib/helpers";
import { getModuleLogger } from "@/server/lib/logger";
import * as collectionService from "@/server/services/collections";

import ExplorePage, { Props } from "@/client/components/pages/Explore";
import { Collection } from "@/shared/types/collection";

const logger = getModuleLogger("pages/collections/[id]/explore");

export const getServerSideProps: GetServerSideProps<Props> = async (
  context
) => {
  try {
    const collectionIdOrSlug = context?.query?.id as string;
    if (
      !collectionIdOrSlug ||
      collectionIdOrSlug === "undefined" ||
      collectionIdOrSlug === "null"
    ) {
      return {
        notFound: true,
      };
    }

    let collection: Collection | null = null;

    // try to read the collection by slug
    collection = await collectionService.readByIdOrSlug(collectionIdOrSlug);

    // if not found with normal slug, try with project database id
    if (!collection) {
      collection =
        await collectionService.readByIdOrProjectId(collectionIdOrSlug);
    }

    // if we still don't have a collection throw an error
    if (!collection) {
      return {
        notFound: true,
      };
    }

    // parse token data if included
    const tokenId = (context.query.tokenId as string) || undefined;
    const hash = (context.query.hash as string) || undefined;

    // Build up props object
    const props: Props = {
      collection: serializeModel(collection),
    };
    if (tokenId) props.tokenId = tokenId;
    if (tokenId) props.hash = hash;

    return {
      props,
    };
  } catch (err) {
    logger.error(err, "failed to fetch collection in getServerSideProps");
    throw err;
  }
};

export default ExplorePage;
